// eventBus.js
import { ref } from "vue";
export const gridInsertionInProgress = ref(false);
